// src/pages/SignUp.js
import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const clientId = "688623649092-l4plb79fp4eiq0ql5s9si3f0fgrrvs7u.apps.googleusercontent.com";

const SignUp = () => {
  const onSuccess = (response) => {
    // Gửi response.tokenId đến backend để xác thực
  };

  const onFailure = (response) => {
  };

  return (
    <div className="bg-[#efefef] text-[#333c4d] min-h-screen p-4 flex flex-col items-center justify-center">
      <h1 className="text-2xl font-bold mb-4">Grow your sport avatar</h1>
      <h2 className="text-xl mb-4">Sign up now!</h2>
      <GoogleOAuthProvider clientId={clientId}>
        <div className="App">
          <GoogleLogin onSuccess={onSuccess} onError={onFailure} />
        </div>
      </GoogleOAuthProvider>
      <button className="bg-black text-white px-4 py-2 rounded mb-4">SIGN UP WITH APPLE</button>
      <button className="bg-blue-500 text-white px-4 py-2 rounded mb-4">SIGN UP WITH SKAL</button>
      <p className="text-sm">Login instead?</p>
      <p className="text-sm">Having issues? <a href="mailto:support@example.com" className="text-blue-500">Email us</a></p>
      <div className="mt-4 text-sm">
        <a href="/term-of-service" className="text-blue-500">Terms of service</a> | <a href="/privacy-policy" className="text-blue-500">Privacy Policy</a>
      </div>
    </div>
  );
};

export default SignUp;